import { isBrowser, isDevelopment } from "../../../../common/helpers/env";
import * as Sentry from "@sentry/react";
import { IUser, IUserState, UserActionTypes } from "../models";
import { LOGIN, FACEBOOK_LOGIN, GOOGLE_LOGIN, GET_USER, LOGOUT, RESET_USER, EDIT_USER, NOTICE_SETTINGS } from "../types";

export default (user: IUserState = null, action: UserActionTypes): IUserState => {
    let data;
    switch (action.type) {
        case LOGIN:
            data = action.payload.data;
            if (action.payload.loading) {
                return { loading: true };
            }
            if (action.payload.error) {
                return { error: true };
            }
            if (data === "tooManyAttempts") {
                return { error: true, validationEmail: "tooManyAttempts" };
            }
            if (data!.success) {
                data!.user.loggedIn = true;
                return data!.user;
            } else {
                return { validationEmail: "loginError", validationPassword: "1" };
            }
        case FACEBOOK_LOGIN:
            data = action.payload.data;
            if (action.payload.loading) {
                return { loading: "facebook" };
            }
            if (action.payload.error) {
                return { error: true };
            }
            if (data!.success) {
                data!.user.loggedIn = true;
                return data!.user;
            } else {
                return { validationEmail: "facebookConnectionError" };
            }
        case GOOGLE_LOGIN:
            data = action.payload.data;
            if (action.payload.loading) {
                return { loading: "google" };
            }
            if (action.payload.error) {
                return { error: true };
            }
            if (data!.success) {
                data!.user.loggedIn = true;
                return data!.user;
            } else {
                return { validationEmail: "googleConnectionError" };
            }
        case GET_USER:
            if (action.payload.data.state === "loggedIn") action.payload.data.loggedIn = true;
            if (action.payload.data.loggedIn && isBrowser) {
                if (!isDevelopment) {
                    Sentry.setUser({
                        id: action.payload.data._id,
                        email: action.payload.data.email,
                    });
                }
            }
            return action.payload.data;
        case LOGOUT:
            return {
                loggedIn: false,
            };
        case RESET_USER:
            return {
                loggedIn: false,
            };
        case EDIT_USER:
            return {
                ...action.payload,
                isTranslator: (user as IUser).isTranslator,
            };
        case NOTICE_SETTINGS:
            return {
                ...(user as IUser)!,
                settingsNoticed: true,
            }
        default:
            return user;
    }
};
